import { RelationshipStrength } from '@/api/profiles.model';
import { ENVIRONMENT } from '@/lib/constants';

const RELATIONSHIP_STRENGH_OPTIONS_API: RelationshipStrength[] =
  ENVIRONMENT === 'production'
    ? [
        {
          dropdownOptionId: 6856975,
          text: 'Weak',
          rank: 1,
          color: 6,
        },
        {
          dropdownOptionId: 6857545,
          text: 'Medium',
          rank: 2,
          color: 2,
        },
        {
          dropdownOptionId: 6857553,
          text: 'Strong',
          rank: 3,
          color: 3,
        },
      ]
    : [
        {
          dropdownOptionId: 8235470,
          text: 'Weak',
          rank: 1,
          color: 3,
        },
        {
          dropdownOptionId: 8235471,
          text: 'Medium',
          rank: 2,
          color: 5,
        },
        {
          dropdownOptionId: 8235472,
          text: 'Strong',
          rank: 3,
          color: 6,
        },
      ];

export { RELATIONSHIP_STRENGH_OPTIONS_API };
